module.exports = __webpack_public_path__ + "static/header-logo-white-xd.3e0bc5d6.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/components/c-header/img/header-logo-white-xd.png
// module id = 743
// module chunks = 2